module.exports = __webpack_public_path__ + "img/list-pattern1.da84847.svg";